// src/reducers/case/service_type.js
import { CREATE_SERVICE_TYPE, RETRIEVE_SERVICE_TYPES, UPDATE_SERVICE_TYPE } from '../../actions/types';

const initialState = {
    items: [],
    totalItems: 0,
    totalPages: 1,
    currentPage: 1,
};

function serviceTypeReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case RETRIEVE_SERVICE_TYPES:
            return {
                ...state,
                items: payload.data,
                totalItems: payload.totalItems,
                totalPages: payload.totalPages,
                currentPage: payload.currentPage,
            };

        case CREATE_SERVICE_TYPE:
            // The list will be re-fetched by the action, so we just wait for RETRIEVE
            return state;

        case UPDATE_SERVICE_TYPE:
            return {
                ...state,
                items: state.items.map((item) => {
                    if (item.service_type_id === payload.service_type_id) {
                        return { ...item, ...payload };
                    } else {
                        return item;
                    }
                }),
            };

        default:
            return state;
    }
}

export default serviceTypeReducer;
